import React from "react";
import EmailTemplate from "../../code/models/EmailTemplate";
import ApiEmailTemplates from "../../code/api/ApiEmailTemplates";
import "../../css/adminnewusertemplates.css";

export default function AdminNewUserEmailTemplates() {
    const [templates, setTemplates] = React.useState<EmailTemplate[]>([]);
    const [signupIds, setSignupIds] = React.useState<number[]>([]);
    const [reactivationIds, setReactivationIds] = React.useState<number[]>([]);

    React.useEffect(() => {
        Promise.all([
            ApiEmailTemplates.getEmailTemplates(),
            ApiEmailTemplates.getSignupTemplateIds(),
            ApiEmailTemplates.getReactivationTemplateIds()
        ]).then(([temps, sIds, rIds]) => {
            setTemplates(temps);
            setSignupIds(sIds);
            setReactivationIds(rIds);
        });
    }, []);

    function handleSignupChange(templateId: number, checked: boolean) {
        const newIds = checked
            ? [...signupIds, templateId]
            : signupIds.filter(id => id !== templateId);
        setSignupIds(newIds);
        ApiEmailTemplates.setSignupTemplateIds(newIds);
    }

    function handleReactivationChange(templateId: number, checked: boolean) {
        const newIds = checked
            ? [...reactivationIds, templateId]
            : reactivationIds.filter(id => id !== templateId);
        setReactivationIds(newIds);
        ApiEmailTemplates.setReactivationTemplateIds(newIds);
    }

    function renderTemplateList(
        sectionKey: string,
        selectedIds: number[],
        onChange: (id: number, checked: boolean) => void
    ) {
        if (templates.length === 0) {
            return <div className="newuser-templates-empty">No email templates available.</div>;
        }
        return templates.map((t) => (
            <div key={`${sectionKey}-${t.emailTemplateId}`} className="form-check newuser-templates-item">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id={`${sectionKey}-chk-${t.emailTemplateId}`}
                    checked={selectedIds.includes(t.emailTemplateId)}
                    onChange={(e) => onChange(t.emailTemplateId, e.target.checked)}
                />
                <label className="form-check-label" htmlFor={`${sectionKey}-chk-${t.emailTemplateId}`}>
                    {t.name}
                </label>
            </div>
        ));
    }

    return (
        <React.Fragment>
            <div className="newuser-templates-main">
                <div className="newuser-templates-section">
                    <h5 className="newuser-templates-header">Signup Emails</h5>
                    <p className="newuser-templates-description">
                        Email Template(s) sent when a new user signs up. They will always get the New Sign Up Email.
                    </p>
                    <div className="newuser-templates-list">
                        {renderTemplateList("signup", signupIds, handleSignupChange)}
                    </div>
                </div>
                <div className="newuser-templates-divider" />
                <div className="newuser-templates-section">
                    <h5 className="newuser-templates-header">Reactivation Emails</h5>
                    <p className="newuser-templates-description">
                        Email Template(s) sent when an existing user reactivates their account. They will always get the Reactivation Email.
                    </p>
                    <div className="newuser-templates-list">
                        {renderTemplateList("reactivation", reactivationIds, handleReactivationChange)}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}